import { BehaviorSubject } from 'rxjs';

export default class ConfirmTokenBloc {
  loading$ = new BehaviorSubject(false);
  message$ = new BehaviorSubject('');
  success$ = new BehaviorSubject(false);
  redirectTo$ = new BehaviorSubject('');

  constructor({ confirmTokenRepository, errorRepository, authRepository }) {
    this.confirmTokenRepository = confirmTokenRepository;
    this.errorRepository = errorRepository;
    this.authRepository = authRepository;
  }

  async confirmToken(token) {
    try {
      if (!token) throw new Error('Token not found. Make sure you have the correct link.');

      this.loading$.next(true);
      const response = await this.confirmTokenRepository.confirmToken(token);

      this.message$.next(response?.message || 'Successfully processed the token. Please login to continue.');
      this.success$.next(true);

      this.errorRepository.error$.next({
        message: response?.message || 'Successfully processed the token. Please login to continue.',
        severity: 'success',
      });

      if (this.authRepository?.auth$.getValue()?.id) {
        this.authRepository.logout();
      }

      this.redirectTo$.next('/login');
    } catch (e) {
      this.success$.next(false);
      this.message$.next(e.message || 'Something went wrong. Please try again.');
      this.redirectTo$.next('/');

      this.errorRepository.error$.next({
        message: e.message || 'Something went wrong. Please try again.',
        severity: 'error',
      });
    } finally {
      this.loading$.next(false);
    }
  }
}
